import React from 'react';
import ReactDOM from 'react-dom';

import 'Src/common/arc_fallback.scss';
import 'Src/common/arc.scss';
import Root from './root';
import './style.scss';

if (document.getElementById('root')) {
  ReactDOM.render(<Root />, document.getElementById('root'));
}
